import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import Inr from '@/components/Inr/index.vue';
import DispatchList from './components/DispatchList.vue';
import { searchDealers } from '@/api/dealers';
import { searchProducts } from '@/api/products';
import { getQuery } from '@/utils';
import moment from 'moment';
import { cleanListQuery } from '@/common';
import { generateInvoice, getOrdersDispatches } from '@/api/orders-dispatches';
import { AdminModule } from '@/store/modules/admin';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.showFilters = false;
    this.dealerListLoading = false;
    this.productListLoading = false;
    this.dealerList = [];
    this.products = [];
    this.dateRange = '';
    this.selectedProduct = null;
    this.listLoading = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.dialogVisible = false;
    this.dispatchId = 0;
    this.loggedInAdmin = null;
    this.branchIds = [];
    this.roles = [];
    this.statusOptions = ['Approved', 'In Transit'];
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.statusColorMap = {
      Approved: 'success',
      'In Transit': 'primary'
    };
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      status: 'In Transit',
      entryNumber: undefined,
      createdTimestamp: undefined,
      applyBranchIdFilter: false,
      'dealers.stockBranchId': undefined,
      'ordersProductsDispatch.ordersProduct.productsVariationId': undefined,
      'ordersProductsDispatch.ordersProduct.productId': undefined,
      sort: 'id,DESC',
      filter: {
        dealerId: '$eq',
        status: '$eq',
        'ordersProductsDispatch.ordersProduct.productsVariationId': '$eq',
        'ordersProductsDispatch.ordersProduct.productId': '$eq',
        entryNumber: '$contL',
        createdTimestamp: 'between',
        'dealer.stockBranchId': '$in'
      }
    };
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    this.branchIds = this.loggedInAdmin.branchIds;
    console.log('Branch Ids: ', this.branchIds);
    if (this.branchIds && this.branchIds.length) {
      this.listQuery['dealer.stockBranchId'] = this.branchIds;
    }
    this.getList();
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      const data = await getOrdersDispatches(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  getFormatedURL(url = null) {
    if (!url) {
      return '#';
    }
    // Check if the URL starts with 'https://'
    if (!url.startsWith('https://')) {
      // If it does not start with 'http://' or 'https://', prepend 'https://'
      if (!url.startsWith('http://')) {
        url = 'https://' + url;
      } else {
        // If it starts with 'http://', replace 'http://' with 'https://'
        url = url.replace('http://', 'https://');
      }
    }
    return url;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        agentId: null
      };
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {
      this.$message.error('Failed to fetch dealers');
    }
  }
  async getProductList(query) {
    try {
      this.productListLoading = true;
      if (query && query.length > 2) {
        this.products = await searchProducts(getQuery({
          keyword: query
        }));
      }
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      throw err;
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  handleProductSelection(value) {
    if (value) {
      if (value.startsWith('product-')) {
        this.listQuery['ordersProductsDispatch.ordersProduct.productId'] = +value.replace('product-', '');
        this.listQuery['ordersProductsDispatch.ordersProduct.productsVariationId'] = undefined;
      } else if (value.startsWith('variation-')) {
        this.listQuery['ordersProductsDispatch.ordersProduct.productId'] = undefined;
        this.listQuery['ordersProductsDispatch.ordersProduct.productsVariationId'] = +value.replace('variation-', '');
      }
    } else {
      // Clear the product filters when value is null or empty
      this.listQuery['ordersProductsDispatch.ordersProduct.productId'] = undefined;
      this.listQuery['ordersProductsDispatch.ordersProduct.productsVariationId'] = undefined;
    }
    this.handleFilter();
  }
  async handleFilter() {
    if (this.dateRange) {
      // Convert the start and end of the date range to UTC
      const startDateUTC = new Date(this.dateRange.start).toISOString();
      const endDateUTC = new Date(this.dateRange.end).toISOString();
      // Assign the date range as UTC timestamps to the list query
      this.listQuery.createdTimestamp = [startDateUTC, endDateUTC].join(',');
    } else {
      // If no date range is provided, set createdTimestamp to undefined
      this.listQuery.createdTimestamp = undefined;
    }
    this.getList();
  }
  async downloadInvoice(id = 0) {
    // get invoice url
    this.listLoading = true;
    const url = await generateInvoice(id);
    if (url) {
      window.open(url, '_blank');
      // const filename = "invoice_" + id + ".pdf";
      // this.downloadFile(data.url, filename);
    } else {
      this.$message({
        message: 'Failed to generate invoice',
        type: 'error'
      });
    }
    this.listLoading = false;
  }
};
default_1 = __decorate([Component({
  name: 'OrdersDispatchList',
  components: {
    Pagination,
    Inr,
    DispatchList
  }
})], default_1);
export default default_1;